import {BaseComponent} from './BaseComponent';
import {AfterViewInit, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatPaginator, MatSort} from '@angular/material';
import {BaseDataSource} from '../datasources/BaseDataSource';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterModel, MainModel} from '../models/GenericModel';
import {GeneralService} from '../services/api/GeneralService';

export abstract class BaseGenericComponent<M extends MainModel, F extends FilterModel, T extends BaseDataSource<M, F>> extends BaseComponent
    implements AfterViewInit, OnInit {

  @Input() showFilter: boolean;
  @Input() showActions: boolean;
  @Input() showPagination: boolean;

  @Input() showSelection: boolean;
  @Output() selectionCallback = new EventEmitter<M>();

  @Input() pageSize: number;

  @Input() readFilterFromMemory: boolean;

  paginator: MatPaginator; // value from @ViewChild
  sort: MatSort;           // value from @ViewChild

  pageSizeOptions = [10, 20, 50, 100];
  sortingFields: { [key: string]: string; } = {};

  dataSource: T;
  filter: F;
  filterShow: boolean;
  displayedColumns: string[];         // must be implemented in every child
  selected: M;
  downloading: boolean;

  filterNameInMemory: string;

  protected constructor(route: ActivatedRoute, router: Router,
                        protected generalService: GeneralService,
                        private mainModelConstructor: new() => M,
                        private dataSourceConstructor: new(isPagination: boolean) => T
  ) {
    super(route, router);
    this.filterShow = false;
    this.filterNameInMemory = mainModelConstructor.name.toLowerCase() + 'Filter';
  }

  protected abstract onInit(): void;

  protected afterViewInit(): void {
    if (this.dataSource.showPagination !== this.showPagination) {
      this.dataSource = new this.dataSourceConstructor(this.showPagination);
      if (this.pageSize !== null) {
        this.dataSource.pageModel.size = this.pageSize;
      }
    }

    this.sort.sortChange.subscribe(() => {
      if (this.showPagination) {
        this.paginator.pageIndex = 0;
      }
      if (this.sort.direction) {
        this.dataSource.pageModel.sortOrder = this.sort.direction;
        this.dataSource.pageModel.sortField = this.sort.active;
      }
      this.loadData();
    });

    if (this.showPagination) {
      this.paginator.page.subscribe(() => this.loadData());
    }
  }

  ngOnInit() {
    this.downloading = false;
    this.showPagination = this.showPagination == null ? false : this.showPagination;
    this.showFilter = this.showFilter == null ? false : this.showFilter;
    this.showActions = this.showActions == null ? false : this.showActions;
    this.readFilterFromMemory = this.readFilterFromMemory == null ? false : this.readFilterFromMemory;
    if (this.readFilterFromMemory && this.generalService.getStoredElement(this.filterNameInMemory)) {
      this.filter = this.generalService.getStoredElement(this.filterNameInMemory);
    }
    this.onInit();
    this.dataSource = new this.dataSourceConstructor(this.showPagination);
    if (this.showPagination) {
      this.dataSource.pageModel.size = 20;
    }
  }

  ngAfterViewInit() {
    this.beforeAfterViewInit();
    this.afterViewInit();
    this.loadData();
  }

  protected beforeAfterViewInit(): void { }

  loadData(): void {
    this.dataSource.filter = this.filter;
    this.dataSource.setPage(this.showPagination ? this.paginator.pageIndex : 0);
    this.dataSource.setSize(this.showPagination ? this.paginator.pageSize : null);
    this.dataSource.loadData();
  }

  filterData() {
    if (this.showPagination) {
      this.paginator.pageIndex = 0;
    }
    this.loadData();
  }

  abstract handleDelete(id: number): void;

  onSelection(selected: M) {
    this.selected = selected;
    this.selectionCallback.emit(selected);
  }

  // abstract handleDownloadList(): void;
}


